import React from 'react';
import type { Principle } from '../../types/content';
import { Reveal } from '../motion/Reveal';
type BenefitListProps = {
  items: Principle[];
  onDark?: boolean;
};
export function BenefitList({
  items,
  onDark = false
}: BenefitListProps) {
  return <ul className={`border-b ${onDark ? 'border-white/15' : 'border-line'}`} data-id="element-263" data-mp="h2at48d9qgb6">
      {items.map((item, index) => <Reveal as="li" key={item.title} delay={Math.min(index, 4) * 50} className={`flex gap-4 border-t py-5 ${onDark ? 'border-white/15' : 'border-line'}`} data-id="element-264" data-mp="19ovs9uzzjwpa" data-mpi={index}>
          <span aria-hidden="true" className="mt-[11px] h-px w-4 shrink-0 bg-gold" data-id="element-265" data-mp="zystfe66noj1" />
          <div data-id="element-266" data-mp="uzzctcvlnhen">
            <h3 className={`text-[15px] font-semibold ${onDark ? 'text-white' : 'text-navy'}`} data-id="element-267" data-mp="v096pbjrm8pm">{item.title}</h3>
            <p className={`mt-1 text-[15px] leading-relaxed ${onDark ? 'text-white/70' : 'text-muted'}`} data-id="element-268" data-mp="1sfmyinoof6zg">
              {item.description}
            </p>
          </div>
        </Reveal>)}
    </ul>;
}